import type { NavigateFunction } from 'react-router-dom';
import type { RemoteUserMenuItem } from '@platform-ui/remote-types';

type UserMenuItemsProps = {
    navigate: NavigateFunction;
    items?: RemoteUserMenuItem[];
};

export function UserMenuItems({ navigate, items = [] }: UserMenuItemsProps) {
    const handleClick = (item: RemoteUserMenuItem) => {
        if (item.externalUrl) {
            window.open(item.externalUrl, '_self');
        } else if (item.path) {
            navigate(item.path);
        }
    };

    return (
        <>
            {items.map(item => (
                <button
                    key={item.id}
                    type="button"
                    role="menuitem"
                    tabIndex={-1}
                    data-slot="dropdown-menu-item"
                    data-variant="default"
                    className="hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground data-[variant=destructive]:text-destructive data-[variant=destructive]:focus:bg-destructive/10 dark:data-[variant=destructive]:focus:bg-destructive/20 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:*:[svg]:text-destructive not-data-[variant=destructive]:focus:**:text-accent-foreground group/dropdown-menu-item relative flex w-full cursor-default items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-hidden select-none data-disabled:pointer-events-none data-disabled:opacity-50 data-inset:pl-8 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4"
                    onPointerMove={event => {
                        if (event.currentTarget !== document.activeElement) {
                            event.currentTarget.focus();
                        }
                    }}
                    onClick={() => handleClick(item)}>
                    <span>{item.label}</span>
                </button>
            ))}
        </>
    );
}
